import { Box, Spinner } from '@factorialco/deprecated-design-system'

export const LoadingState = () => (
  <Box alignItems="center" justifyContent="center" height="full">
    <Spinner />
  </Box>
)
